import React, { Component } from "react";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import SwiperCore, { Autoplay } from "swiper";
import "@/assets/styles/animates.scss";
SwiperCore.use([Autoplay]);
class Product extends Component {
  state = {
    news_show: false,
    mySwiper_about: null,
    autoplay_delay: 6000,
  };
  componentDidMount() {
    this.props.componentRef(this, "news");
  }
  slideChange = (e) => {
    // console.log("news:" + e.realIndex);
    // switch (e.realIndex) {
    //   case 0:
    //     this.setState({
    //       about_1_show: true,
    //       about_2_show: false,
    //     });
    //     break;
    //   case 1:
    //     this.setState({
    //       about_1_show: false,
    //       about_2_show: true,
    //       about_3_show: false,
    //     });
    //     break;
    //   case 2:
    //     this.setState({
    //       about_2_show: false,
    //       about_3_show: true,
    //       about_4_show: false,
    //     });
    //     break;
    //   default:
    //     this.setState({
    //       about_3_show: false,
    //       about_4_show: true,
    //     });
    //     break;
    // }
    // if (e.realIndex === 0) {
    //   this.setState({
    //     allowSlidePrev: false,
    //     allowSlideNext: true,
    //   });
    // } else if (e.realIndex === 3) {
    //   this.setState({
    //     allowSlidePrev: true,
    //     allowSlideNext: false,
    //   });
    // } else {
    //   this.setState({
    //     allowSlidePrev: true,
    //     allowSlideNext: true,
    //   });
    // }
  };
  setSwiper_news = (el) => {
    this.setState({
      mySwiper_news: el,
    });
  };
  // 跳转公众号文章
  openPage = (e, index) => {
    // console.log(index);
    let url = "";
    switch (index) {
      case 1:
        url = "https://mp.weixin.qq.com/s/oNH1PSV9ZZgwF-OWp1eEsQ";
        break;
      case 2:
        url = "https://mp.weixin.qq.com/s/8ZLoX5qZnVCHZshvY6BDLA";
        break;
      case 3:
        url = "https://mp.weixin.qq.com/s/2u5VPVhebZSYqk7S1p7gfg";
        break;
      case 4:
        url = "https://mp.weixin.qq.com/s/3YtfNiPZsHIQuP9b4TncVg";
        break;

      default:
        break;
    }
    window.open(url);
  };
  render() {
    const news_content = JSON.parse(this.props.news_content);
    // const news_list = JSON.parse(this.props.news_list);
    return (
      <div className="news_bg">
        <div className="news">
          <h1 className="title">{news_content.title}</h1>
          <div className="doc">{news_content.doc}</div>
          <Swiper
            className="mySwiper_news"
            slidesPerView={3}
            centeredSlides={true}
            spaceBetween={100}
            grabCursor={true}
            // initialSlide={2}
            pagination={{
              clickable: true,
            }}
            loop={true}
            // onSwiper={this.setSwiper_news}
            // onSlideChange={this.slideChange}
            autoplay={{
              delay: 4000,
              pauseOnMouseEnter: true,
              disableOnInteraction: false,
            }}
            style={{
              "--swiper-pagination-bullet-width": "8px",
              "--swiper-pagination-bullet-height": "8px",
              "--swiper-pagination-color": "#5ab5f0",
              "--swiper-pagination-bullet-inactive-color": "none",
              "--swiper-pagination-bullet-inactive-opacity": ".8",
            }}
          >
            <SwiperSlide>
              <div className="new-card-list">
                <img
                  className="new-card"
                  src={require("@/assets/images/news_1.png").default}
                  alt=""
                  onClick={(e) => this.openPage(e, 1)}
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="new-card-list">
                <img
                  className="new-card"
                  src={require("@/assets/images/news_2.png").default}
                  alt=""
                  onClick={(e) => this.openPage(e, 2)}
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="new-card-list">
                <img
                  className="new-card"
                  src={require("@/assets/images/news_3.png").default}
                  alt=""
                  onClick={(e) => this.openPage(e, 3)}
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="new-card-list">
                <img
                  className="new-card"
                  src={require("@/assets/images/news_4.png").default}
                  alt=""
                  onClick={(e) => this.openPage(e, 4)}
                />
              </div>
            </SwiperSlide>
          </Swiper>
          {/* <div className="new-bottom"></div> */}
          {/* {news_list.map((val, index) => (
            <div className="news_list" key={index}>
              {CSSTrans(
                this.state.news_show,
                "fadeInUp_trans",
                <img
                  className="news_img"
                  src={require("@/assets/images/" + val.imgName).default}
                  alt=""
                />
              )}
              {CSSTrans(
                this.state.news_show,
                "fadeInUp_trans",
                <div className="news_title">{val.title}</div>
              )}
            </div>
          ))} */}
        </div>
      </div>
    );
  }
}
export default Product;
